export const getUnitListByMaterial = (unitGroupDetailList, materialCode, materialCodeVer) => {
    if (!unitGroupDetailList || !materialCode || !materialCodeVer) return [];

    return unitGroupDetailList.filter(
        (item) => item.materialCode === materialCode && item.materialCodeVer === materialCodeVer
    );
};

export const getPurposeListByMaterial = (unitPurposeList, materialCode, materialCodeVer) => {
    if (!unitPurposeList || !materialCode || !materialCodeVer) return [];

    return unitPurposeList.filter(
        (item) => item.materialCode === materialCode && item.materialCodeVer === materialCodeVer
    );
};

export const getBaseUnit = (unitList) => {
    if (!unitList || unitList.length === 0) return null;

    return unitList.find((item) => item.unitId === item.baseUnitId);
};

export const getSelectedUnitForPurpose = (unitList, purposeList, selectedPurpose) => {
    if (!unitList || !purposeList || !selectedPurpose) return null;

    const purposeUnit = purposeList.find((item) => item.unitPurposeId === selectedPurpose.unitPurposeId);
    if (!purposeUnit) return null;

    return unitList.find((item) => item.unitId === purposeUnit.unitId);
};

export const calculateConvertedQuantity = (originalQuantity, conversionFactor) => {
    if (!originalQuantity || !conversionFactor || conversionFactor === 0) return 0;

    return (originalQuantity / conversionFactor).toFixed(4);
};

export const determineDisplayUnit = (unitList, purposeList, selectedPurpose) => {
    if (!unitList || unitList.length === 0) return null;

    if (purposeList && purposeList.length > 0 && selectedPurpose) {
        const purposeUnit = getSelectedUnitForPurpose(unitList, purposeList, selectedPurpose);
        if (purposeUnit) return purposeUnit;
    }

    return getBaseUnit(unitList);
};

export const getPurposes = (unitPurposeList) => {
    if (!unitPurposeList || unitPurposeList.length === 0) return [];

    const purposeMap = {};
    return unitPurposeList.reduce((acc, item) => {
        if (!purposeMap[item.unitPurposeId]) {
            purposeMap[item.unitPurposeId] = true;
            acc.push({
                purposeName: item.purposeName,
                unitPurposeId: item.unitPurposeId,
            });
        }
        return acc;
    }, []);
};
